/**
 * 错误码常量定义
 * 统一管理 API 错误码和对应的用户友好提示
 */

export const ERROR_CODES = {
  // 网络错误
  NETWORK_ERROR: 'NETWORK_ERROR',
  TIMEOUT: 'TIMEOUT',
  
  // 认证错误
  UNAUTHORIZED: 'UNAUTHORIZED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  FORBIDDEN: 'FORBIDDEN',
  
  // 业务错误
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
  
  // 未知错误
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
}

/**
 * 错误码到 i18n key 的映射
 */
export const ERROR_I18N_MAP = {
  [ERROR_CODES.NETWORK_ERROR]: 'Error_Network',
  [ERROR_CODES.TIMEOUT]: 'Error_Timeout',
  [ERROR_CODES.UNAUTHORIZED]: 'Error_Unauthorized',
  [ERROR_CODES.TOKEN_EXPIRED]: 'Error_TokenExpired',
  [ERROR_CODES.FORBIDDEN]: 'Error_Forbidden',
  [ERROR_CODES.VALIDATION_ERROR]: 'Error_Validation',
  [ERROR_CODES.NOT_FOUND]: 'Error_NotFound',
  [ERROR_CODES.SERVER_ERROR]: 'Error_Server',
  [ERROR_CODES.UNKNOWN_ERROR]: 'Error_Unknown'
}

/**
 * HTTP 状态码到错误码的映射
 */
export const HTTP_STATUS_TO_ERROR = {
  400: ERROR_CODES.VALIDATION_ERROR,
  401: ERROR_CODES.UNAUTHORIZED,
  403: ERROR_CODES.FORBIDDEN,
  404: ERROR_CODES.NOT_FOUND,
  408: ERROR_CODES.TIMEOUT,
  500: ERROR_CODES.SERVER_ERROR,
  502: ERROR_CODES.SERVER_ERROR,
  503: ERROR_CODES.SERVER_ERROR,
  504: ERROR_CODES.TIMEOUT
}
